"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _spauiIcon = _interopRequireDefault(require("@tencent/spaui-icon"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var BodyComponent =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(BodyComponent, _React$PureComponent);

  function BodyComponent() {
    _classCallCheck(this, BodyComponent);

    return _possibleConstructorReturn(this, _getPrototypeOf(BodyComponent).apply(this, arguments));
  }

  _createClass(BodyComponent, [{
    key: "getIconTypeDom",
    // 获取置顶iconType的dom结构
    value: function getIconTypeDom() {
      var _this$props = this.props,
          _this$props$iconType = _this$props.iconType,
          iconType = _this$props$iconType === void 0 ? '' : _this$props$iconType,
          children = _this$props.children,
          _this$props$tipConten = _this$props.tipContentStyle,
          tipContentStyle = _this$props$tipConten === void 0 ? {} : _this$props$tipConten;
      var iconDom = null;

      if (iconType) {
        // 有样式的就用指定的图标，如果没有就用Icon组件的
        if (iconType === 'loading' || iconType === 'success' || iconType === 'strongwarn' || iconType === 'info' || iconType === 'error' || iconType === 'warn') {
          iconDom = _react["default"].createElement("i", {
            className: "spaui-alert-icon icon-".concat(iconType)
          });
        } else {
          iconDom = _react["default"].createElement(_spauiIcon["default"], {
            type: iconType
          });
        }
      }

      return _react["default"].createElement("div", {
        className: "spaui-alert ".concat(iconType),
        style: tipContentStyle
      }, iconDom, _react["default"].createElement("div", {
        className: "spaui-alert-content"
      }, children));
    }
  }, {
    key: "render",
    value: function render() {
      var _classNames2;

      var _this$props2 = this.props,
          type = _this$props2.type,
          bodyStyle = _this$props2.bodyStyle,
          children = _this$props2.children,
          bodyClassName = _this$props2.bodyClassName,
          iconType = _this$props2.iconType,
          enabledBackgroundColor = _this$props2.enabledBackgroundColor,
          useNewUI = _this$props2.useNewUI;

      if (useNewUI) {
        return _react["default"].createElement("div", {
          className: (0, _classnames["default"])('spaui-dialog-body', _defineProperty({}, bodyClassName, true)),
          style: bodyStyle
        }, children);
      }

      return _react["default"].createElement("div", {
        className: (0, _classnames["default"])('modal-body', (_classNames2 = {}, _defineProperty(_classNames2, bodyClassName, true), _defineProperty(_classNames2, "spaui-alert-".concat(iconType), type === 'tip' && enabledBackgroundColor), _classNames2)),
        style: bodyStyle
      }, type === 'tip' ? this.getIconTypeDom() : children);
    }
  }]);

  return BodyComponent;
}(_react["default"].PureComponent);

var _default = BodyComponent;
exports["default"] = _default;